import React, { useState, useRef, useEffect, FC } from 'react';
import { CustomShowMoreContainer } from './styles';
import { useTranslation } from 'react-i18next';

const CustomShowMore: FC<{ text: string, maxLines: number, isDark?: boolean }> = ({ text, maxLines = 3, isDark }) => {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      const maxHeight = lineHeight * maxLines;
      setIsOverflowing(element.scrollHeight > maxHeight);
    }
  }, [text, maxLines]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <CustomShowMoreContainer className="show-more-container" isDark={isDark}>
      <div
        ref={textRef}
        className={`show-more-text ${isExpanded ? '' : 'collapsed'}`}
        style={{ WebkitLineClamp: isExpanded ? 'unset' : maxLines }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {isOverflowing && (
        <span className="show-more-wrapper">
          <button
            onClick={toggleExpand}
            className="show-more-button"
          >
            {isExpanded ? t('show_less_text'): t('show_more_text')}
          </button>
        </span>
      )}
    </CustomShowMoreContainer>
  );
};

export default CustomShowMore;import React, { useState, useRef, useEffect, FC } from 'react';
import { CustomShowMoreContainer } from './styles';
import { useTranslation } from 'react-i18next';

const CustomShowMore: FC<{ text: string, maxLines: number, isDark?: boolean }> = ({ text, maxLines = 3, isDark }) => {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      const maxHeight = lineHeight * maxLines;
      setIsOverflowing(element.scrollHeight > maxHeight);
    }
  }, [text, maxLines]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <CustomShowMoreContainer className="show-more-container" isDark={isDark}>
      <div
        ref={textRef}
        className={`show-more-text ${isExpanded ? '' : 'collapsed'}`}
        style={{ WebkitLineClamp: isExpanded ? 'unset' : maxLines }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {isOverflowing && (
        <span className="show-more-wrapper">
          <button
            onClick={toggleExpand}
            className="show-more-button"
          >
            {isExpanded ? t('show_less_text'): t('show_more_text')}
          </button>
        </span>
      )}
    </CustomShowMoreContainer>
  );
};

export default CustomShowMore;